import React, { useEffect, useState, useMemo } from "react";
import PageTemplate from "../../Templates/PageTemplate";
import { Tab, Tabs } from "react-bootstrap";
import Cookies from 'universal-cookie';
import { useNavigate } from "react-router";
import TablePreset from "../../Table/TablePreset";
import { useTable } from "react-table";
import { BackButton, ButtonBlue } from "../../HouseStyle/Components/Buttons";
import Backbutton from "../Icons/BackIcon.svg";
import { BorderedTextInput } from '../../HouseStyle/Components/Inputs';
import middleware from "../../Api/Middleware";
import SystemInfo from "./Tabs/SytemInfo";
import EmailSettings from "./Tabs/EmailSettings";
import * as Icons from "../../HouseStyle/Icons";
import ToastError from "../../Toasts/ToastError";
import ToastSuccess from "../../Toasts/ToastSuccess";
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns.js";
import { data, dns, spf, dmarc } from './temporarydata.js';
import TDSDTextNavigation from "../../Templates/TDSTextNavigation.js";

const TechnicalSettings = () => {
  //loading
  const [loading, setLoading] = useState(true);
  // Navigation setup
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [key, setKey] = useState("tab1");

  // Company info code
  const [settings, setSettings] = useState({});

  // temporary data voor de tabbelen
  const [testData, setTestData] = useState([]);
  const [dnsData, setDnsData] = useState([]);
  const [spfData, setSpfData] = useState([]);
  const [dmarcData, setDmarcData] = useState([]);

  // Verzend instellingen
  const [shippingProviders, setShippingProviders] = useState([]);
  const [defaultProvider, setDefaultProvider] = useState(null);
  const [defaultMethod, setDefaultMethod] = useState(null);
  const [providerMethods, setProviderMethods] = useState([]);

  const fetchSettings = async () => {
    setLoading(true);

    try {
      const systemResponse = await middleware.get("/settings/system");
      const systemData = systemResponse.data?.data || [];

      if (systemData.length === 0) {
        ToastError("Systeeminstellingen ontbreken.");
      }

      setSettings(systemData);
    } catch (err) {
      console.error("Error fetching system settings:", err);
      ToastError("Kon systeeminstellingen niet ophalen.");
    }

    // Static/mock data
    setTestData(data);
    setDnsData(dns);
    setSpfData(spf);
    setDmarcData(dmarc);

    setLoading(false);
  };

  // Ophalen providers en settings
  useEffect(() => {
    async function fetchShippingSettings() {
      try {
        const providersRes = await middleware.get("/shipments/providers");
        setShippingProviders(providersRes.data.filter(p => p.provider_in_use === 1));
        const settingsRes = await middleware.get("/settings/shipping");
        setDefaultProvider(
          settingsRes.data.data.default_provider_id !== undefined && settingsRes.data.data.default_provider_id !== null
            ? parseInt(settingsRes.data.data.default_provider_id, 10)
            : null
        );
        setDefaultMethod(
          settingsRes.data.data.default_provider_method_id !== undefined && settingsRes.data.data.default_provider_method_id !== null
            ? parseInt(settingsRes.data.data.default_provider_method_id, 10)
            : null
        );
      } catch (err) {
        ToastError("Kon verzendinstellingen niet ophalen.");
      }
    }
    fetchShippingSettings();
  }, []);

  // Methoden ophalen bij provider
  useEffect(() => {
    if (defaultProvider === null) {
      setProviderMethods([]);
      return;
    }
    const provider = shippingProviders.find(p => p.provider_id == defaultProvider);
    setProviderMethods(provider ? provider.methods.filter(m => m.method_in_use === 1) : []);
  }, [defaultProvider, shippingProviders]);

  // Opslaan
  const saveShippingSettings = async () => {
    try {
      await middleware.put("/settings/shipping", {
        default_provider_id: defaultProvider,
        default_provider_method_id: defaultMethod
      });
      ToastSuccess("Verzendinstellingen opgeslagen.");
    } catch (err) {
      ToastError("Opslaan mislukt.");
    }
  };

  useEffect(() => {
    fetchSettings();
  }, [])

  // Tabs for navigation
  const tabs = [
    {
      eventKey: "tab1",
      title: "Systeem informatie",
      navbarTitle: "Systeem informatie",
      content: (key == "tab1" && <SystemInfo settings={settings} />),
    },
    {
      eventKey: "tab2",
      title: "Verzend informatie",
      navbarTitle: "Verzend informatie",
      content: (key == "tab2" && (
        <div className="whiteBox col-12 mt-4 px-4">
          <h4 className="fw-bold ms-4 py-2 pt-3">Standaard verzendinstellingen</h4>
          <div className="d-flex flex-row gap-4 ms-4 py-2 pt-3 w-75 pb-4">
            <div className="me-4 w-50">
              <label className="fw-semibold mb-2">Standaard pakketprovider</label>
              <BorderedDropDown
                placeholder="Selecteer provider"
                options={[
                  { value: null, title: "Selecteer provider" },
                  ...shippingProviders.map(p => ({ value: p.provider_id, title: p.provider_name }))
                ]}
                selectedValue={defaultProvider}
                setSelectedValue={val => setDefaultProvider(val)}
              />
            </div>
            <div className="me-4 w-50">
              <label className="fw-semibold mb-2">Standaard verzendmethode</label>
              <BorderedDropDown
                placeholder="Selecteer verzendmethode"
                options={[
                  { value: null, title: "Selecteer verzendmethode" },
                  ...providerMethods.map(m => ({ value: m.provider_method_id, title: m.name }))
                ]}
                selectedValue={defaultMethod}
                setSelectedValue={val => setDefaultMethod(val)}
              />
            </div>
          </div>
          <div className="ms-4">
            <ButtonBlue text="Opslaan" onClickFunction={saveShippingSettings} />
          </div>
        </div>
      )),
    },
    {
      eventKey: "tab3",
      title: "E-mail instellingen",
      navbarTitle: "E-mail instellingen",
      content: (key == "tab3" && <EmailSettings />),
    },
  ];

  const columns = useMemo(() => {
    return [
      {
        Header: () => <p className="FlatText mb-0">TXT-records gevonden voor dit domein</p>,
        accessor: "records",
        Cell: ({ row }) => {
          return (
            <div className="text-start">
              {row.original.records}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">TTL</p>,
        accessor: "ttl",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              {row.original.ttl}
            </div>
          );
        },
      },
    ];
  }, [testData]);

  const columnsDNS = useMemo(() => {
    return [
      {
        Header: () => <p className="FlatText mb-0">Opgeslagen gegevens</p>,
        accessor: "data",
        Cell: ({ row }) => {
          return (
            <div className="text-start">
              {row.original.data}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0"></p>,
        accessor: "type",
        Cell: ({ row }) => {
          return (
            <div className="BlackText fw-bold">
              {row.original.type}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">TTL</p>,
        accessor: "ttl",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              {row.original.ttl}
            </div>
          );
        },
      },
    ];
  }, [dnsData]);

  const columnsSPF = useMemo(() => {
    return [
      {
        Header: () => <p className="FlatText mb-0">Host</p>,
        accessor: "host",
        Cell: ({ row }) => {
          return (
            <div className="text-start">
              {row.original.host}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">IP / Doelwit</p>,
        accessor: "ip",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              IP: {row.original.ip}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">SPF</p>,
        accessor: "spf",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              {row.original.spf}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">SPF onbewerkt</p>,
        accessor: "spfunedit",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              {row.original.spfunedit}
            </div>
          );
        },
      },
    ];
  }, [spfData]);

  const columnsDMARC = useMemo(() => {
    return [
      {
        Header: () => <p className="FlatText mb-0">TXT-records gevonden voor dit domein</p>,
        accessor: "records",
        Cell: ({ row }) => {
          return (
            <div className="text-start">
              {row.original.records}
            </div>
          );
        },
      },
      {
        Header: () => <p className="FlatText mb-0">TTL</p>,
        accessor: "ttl",
        Cell: ({ row }) => {
          return (
            <div className="BlackText">
              {row.original.ttl}
            </div>
          );
        },
      },
    ];
  }, [dmarcData]);

  const pagination = [];
  const tableInstance = useTable({ columns, data: testData });
  const tableInstanceDNS = useTable({ columns: columnsDNS, data: dnsData });
  const tableInstanceSPF = useTable({ columns: columnsSPF, data: spfData });
  const tableInstanceDMARC = useTable({ columns: columnsDMARC, data: dmarcData });

  return <PageTemplate navbarTitle={"Technische instellingen"} pageIsLoading={loading}>
    <div className="d-flex w-100 flex-column">
      <div className="d-flex mb-4 justify-content-between">
        <BackButton size="l" text={"Terug"} onClickFunction={() => navigate("/algemene/instellingen")} />
      </div>
      <div className='col-12'>
        <div className="tabContainer whiteBox companyInfoTabs px-4 tabsOverviewPadding col-12 justify-content-start">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
              setKey(k);
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.eventKey}
                eventKey={tab.eventKey}
                title={
                  <span
                    className={`tab-title ${key === tab.eventKey ? "active" : ""} fw-semibold`}
                  >
                    {tab.title}
                  </span>
                }
                disabled={tab.disabled}
              >
                <div key={tab.eventKey} className="tabContent">{tab.content}</div>
              </Tab>
            ))}
          </Tabs>
        </div>
        {key == 'tab1' ?
          <div className="whiteBox col-12 mt-4 px-4">
            <h4 className="fw-bold ms-4 py-2 pt-3">Ontwikkelaarsinformatie</h4>
            <div className="d-flex  ms-4 py-2 pt-3 w-50 justify-content-between pb-4">
              <h6 className="w-25 fw-bold">API</h6>
              <TDSDTextNavigation text={middleware.getUri()} link={middleware.getUri()} openNewTab={true} />
            </div>
          </div> : ""
        }
        {/* {key == 'tab3' ?
          <div>
            <div className="whiteBox col-12 mt-4 px-4">
              <div className="d-flex justify-content-between">
                <p className="fw-bold pt-2">Je moet het volgende TXT record toevoegen aan de DNs configuratie van jouw domein (UnifeidSMB.com)</p>
                <ButtonBlue text={"Opnieuw valideren"} icon={Icons.Sync} iconPlacement={"left"} />
              </div>
              <div className="d-flex  ms-4 py-2 pt-3 w-50 justiy-content-between pb-4">
                <div className="me-4">
                  <BorderedTextInput
                    buttonLabel='Kopieer'
                    textBoxInfront='TXT'
                    prefixLabel="Type"
                    label="Host"
                    inputValue={''}
                    setInputValue={''}
                    size='l'
                    updateFunction={''}
                  />
                </div>
                <BorderedTextInput
                  buttonLabel='Kopieer'
                  label="Waarde"
                  inputValue={''}
                  setInputValue={''}
                  size='l'
                  updateFunction={''}
                />
              </div>
              <p className="BeneathFlatText DarkGreyText ms-4">Als u de DNS-instellingen al op een hierboven hebt geconfigureerd, duurt het even voordat het probleem is opgelost. Probeer het opnieuw na 24 uur. We zullen het op de achtergrond blijven controleren. U kunt deze pagina sluiten.</p>
              <div>
                <TablePreset
                  data={[{ 'tableInstance': tableInstance, 'pagination': pagination, 'primary_key': 'row_id' }]}
                  emptyTableHeight="xs"
                  tableLoading={''}
                  showcheckbox={false}
                />
              </div>
            </div>
            <div className="whiteBox col-12 mt-4 px-4">
              <p className="TableTitle pt-2">DNS configuratie van unifiedSMB.com</p>
              <TablePreset
                data={[{ 'tableInstance': tableInstanceDNS, 'pagination': pagination, 'primary_key': 'row_id' }]}
                emptyTableHeight="xs"
                tableLoading={''}
                showcheckbox={false}
              />
            </div>
            <div className="whiteBox col-12 mt-4 px-4">
              <p className="TableTitle pt-2">SPF van UnifiedsMB.com</p>
              <TablePreset
                data={[{ 'tableInstance': tableInstanceSPF, 'pagination': pagination, 'primary_key': 'row_id' }]}
                emptyTableHeight="xs"
                tableLoading={''}
                showcheckbox={false}
              />
            </div>
            <div className="whiteBox col-12 mt-4 px-4">
              <p className="TableTitle pt-2">DMARC voor unifiedSMB.com</p>
              <TablePreset
                data={[{ 'tableInstance': tableInstanceDMARC, 'pagination': pagination, 'primary_key': 'row_id' }]}
                emptyTableHeight="xs"
                tableLoading={''}
                showcheckbox={false}
              />
            </div>
          </div>
          : ""
        } */}
      </div>
    </div>
  </PageTemplate>
}

export default TechnicalSettings;